import { render } from "./ExteriorCardSkeleton.vue?vue&type=template&id=24b996c5&scoped=true"
const script = {}

import "./ExteriorCardSkeleton.vue?vue&type=style&index=0&id=24b996c5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b996c5"]])

export default __exports__